export const SOFTLINE_API_PRODUKTIONSAUFTRAG_QUERY = '/v1/produktion/produktionsauftrag/query'
export const SOFTLINE_API_PRODUKTIONSAUFTRAG_UPDATE_REZEPT = '/v1/produktion/beweau/entities/updateRezept';
export const SOFTLINE_API_PRODUKTIONSAUFTRAG_UPDATE_STATUS = '/v1/produktion/beweau/entities/{{idkopfpr}}';

export const SOFTLINE_API_PRODUKTIONSAUFTRAG_BEWEPR = '/v1/produktion/bewepr/entities'
export const SOFTLINE_API_PRODUKTIONSAUFTRAG_BEWEAU = '/v1/produktion/beweau/entities'
